var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "name-cell" },
    [
      _vm.record.isWorker
        ? _c("c-button", {
            directives: [
              {
                name: "b-popover",
                rawName: "v-b-popover.html",
                value: {
                  container: "#app",
                  trigger: "hover blur",
                  content: "Клиент отмечен как сотрудник",
                  placement: "top",
                },
                expression:
                  "{\n      container: '#app',\n      trigger: 'hover blur',\n      content: 'Клиент отмечен как сотрудник',\n      placement: 'top',\n    }",
                modifiers: { html: true },
              },
            ],
            attrs: { size: "iconic", icon: "employee" },
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "name-cell-client-name",
          class: { "name-cell-client-name-worker": _vm.record.isWorker },
        },
        [_vm._v(" " + _vm._s(_vm.record.name.value) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }